import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";

import { Nav } from "@/components/sections/Nav";
import { Hero } from "@/components/sections/Hero";
import { About } from "@/components/sections/About";
import { Turmas } from "@/components/sections/Turmas";
import { Horarios } from "@/components/sections/Horarios";
import { Planos } from "@/components/sections/Planos";
import { Professores } from "@/components/sections/Professores";
import { LeadForm } from "@/components/sections/LeadForm";
import { Localizacao } from "@/components/sections/Localizacao";
import { Footer } from "@/components/sections/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

function App() {
  useEffect(() => {
    const reduce = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (reduce) return;

    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-paper min-h-screen">
      <Toaster theme="light" position="top-center" richColors />
      <Nav />
      <main>
        <Hero />
        <About />
        <Turmas />
        <Horarios />
        <Planos />
        <Professores />
        <LeadForm />
        <Localizacao />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
